import styled from 'styled-components'

const CardIcon = styled.i`
    font-size: 1.2rem;
    color: #4a4a4a;
    margin-right: 1rem;
`

export default CardIcon